import { useState } from 'react';
import { Grid, Tabs, Tab } from '@mui/material';
import GeneralInfo from './project-info/general-info/GeneralInfo';
import Assets from './project-info/assets/Assets';

const PROJECT_INFO_TABS = [
    'General Info',
    'Assets',
    'Lab Tests'
]

/**
 * Shared component between Flame Cap Kilns and Conservation Burns
 * @param {Object} props 
 * @param {'Flame Cap Kiln' | 'Conservation Burns'} props.burnType Prop drilled down from Programs.js
 * @returns {JSX.Element}
 */

export default function ProjectInfo({ burnType }) {
    const [selectedTab, setSelectedTab] = useState('General Info');

    return (
        <Grid container gap={3}>
            <Grid item sx={{ display: 'flex', width: '100%' }}>
                <Tabs
                    value={selectedTab}
                    onChange={(event, selectedTab) => setSelectedTab(selectedTab)}
                >
                    {PROJECT_INFO_TABS.map((tab) => (
                        <Tab
                            key={tab}
                            label={tab}
                            value={tab}
                            disabled={tab === 'Lab Tests'}
                        />
                    ))}
                </Tabs>
            </Grid>
            {
                selectedTab === 'General Info' &&
                <GeneralInfo />
            }
            {
                selectedTab === 'Assets' &&
                <Assets burnType={burnType} />
            }
        </Grid>
    );
}
